import { lazy } from 'react'
import { FileSignature, FileText, Receipt } from 'lucide-react'

/** Onglets du menu Contrats : devis -> contrats -> factures. */
export const CONTRACT_SECTIONS = [
  { key: 'devis', label: 'Devis', icon: FileText, component: lazy(() => import('./pages/QuotesPage.jsx')) },
  { key: 'contrats', label: 'Contrats', icon: FileSignature, component: lazy(() => import('./pages/ContractListPage.jsx')) },
  { key: 'factures', label: 'Factures', icon: Receipt, component: lazy(() => import('./pages/InvoicesPage.jsx')) },
]
